module.exports = __webpack_public_path__ + "img/logo.bd96d4dc.png";